<template>
  <div :class="isSP ? 'article--sp' : 'article--pc'">
    <a :class="isSP ? 'article__element--sp' : 'article__element--pc'" v-for="n in 6" :key="n"
       :href="links[n - 1]" target="_blank">
      <v-img :class="isSP ? 'article__element__img--sp' : 'article__element__img--pc'"
             :src="require('@/assets/img/article' + n + '.jpeg')" />
      <h2 :class="isSP ? 'article__element__title--sp' : 'article__element__title--pc'">{{ titles[n - 1] }}</h2>
    </a>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // リンク
      links: [
        'https://ideasforgood.jp/2019/09/30/nukumo/',
        'https://mainichi.jp/premier/politics/articles/20200303/pol/00m/010/004000c',
        'https://note.com/akitonz/n/nc50013bdcf68',
        'https://gakusei-kichi.com/?p=46485https://gakusei-kichi.com/?p=46485',
        'https://www.apufafa-j.com/single-post/2019/11/29/Trash-Kitchen%EF%BC%8D%E7%A4%BE%E4%BC%9A%E8%B5%B7%E6%A5%AD%E5%AE%B6%E3%81%AE%E3%82%AD%E3%83%83%E3%83%81%E3%83%B3',
        'https://ogu-rin.com/works/trash-kitchen/'
      ],
      // タイトル
      titles: [
        'Trash Kitchenを運営していたnukumoという会社について',
        'フードロスを活用した新ビジネス',
        'フードロスを活用した飲食店『Trash Kichen』オープンまでの流れと振り返り',
        '環境に優しく食を楽しもう！/ Trash Kicthen',
        'Trash Kitchen - 社会起業家のキッチン',
        'Trash Kithcen - フードロス削減を目指した飲食店'
      ]
    }
  },
  computed: {
    /**
     * @return {Boolean} SPかどうか
     */
    isSP () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
        navigator.userAgent
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/sass/size.scss';
@import '@/assets/sass/color.scss';

.article {
  width: 100vw;
  &--sp {
    @extend .article;
  }
  &--pc {
    @extend .article;
    padding: 0 265px;
  }
  &__element {
    display: block;
    &--sp {
      @extend .article__element;
      display: flex;
      align-items: center;
      padding: 0 20px;
      margin-top: 20px;
    }
    &--pc {
      @extend .article__element;
      display: inline-block;
      margin: 40px;
      vertical-align: top;
    }
    &__img {
      &--sp {
        @extend .article__element__img;
        flex: initial;
        min-width: 100px;
        max-width: 100px;
        height: 80px;
      }
      &--pc {
        @extend .article__element__img;
        min-width: 250px;
        max-width: 250px;
        height: 200px;
      }
    }
    &__title {
      margin: 0;
      font-weight: normal;
      color: $black_color;
      text-align: left;
      &--sp {
        @extend .article__element__title;
        margin-left: 20px;
        font-size: 1.2rem;
      }
      &--pc {
        @extend .article__element__title;
        width: 250px;
        margin-top: 15px;
        font-size: 1.8rem;
      }
    }
  }
}
</style>
